import { upperCase } from 'es-toolkit';
import React, { useCallback, useState } from 'react';
import { Box, CssBaseline, Tab, Tabs } from '@mui/material';

import devTools from '@paragon/dev-tools';
import { LoginContainer } from '@paragon/login-tools';
import { ParagonHeader } from '@paragon/material';
import { getSpinnersToDisplay, SpinnerMessage } from '@paragon/task-spinner';
import { UserDropdown } from '@paragon/themes';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { Batch } from './batch/Batch';
import { Compare } from './compare/Compare';
import { Convert } from './convert/Convert';
import { Count } from './count/Count';
import { useAppSelector } from './hooks';

const tabs = ['convert', 'compare', 'count', 'batch'] as const;

export function Root() {
  const spinnerMessages = useAppSelector(getSpinnersToDisplay);

  const [activeTab, setActiveTab] = useState<(typeof tabs)[number]>('convert');

  const handleTabChange = useCallback((_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(tabs[newValue]);
  }, []);

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          position: 'absolute',

          width: '100%',
          height: '100%',

          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <LoginContainer requirePermission="convert-access">
          <ParagonHeader renderDevToolsButton={false}>
            <Tabs value={tabs.indexOf(activeTab)} onChange={handleTabChange}>
              {tabs.map((tab) => (
                <Tab key={tab} label={upperCase(tab)} />
              ))}
            </Tabs>

            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
              <UserDropdown />
              {devTools.renderDevToolsButton()}
            </Box>
          </ParagonHeader>

          <Box component="main" sx={{ flexGrow: 1, padding: 3 }}>
            {Array.from(spinnerMessages).map((text) => (
              <SpinnerMessage text={text} key={text} />
            ))}

            {activeTab === 'convert' ? (
              <Convert />
            ) : activeTab === 'compare' ? (
              <Compare />
            ) : activeTab === 'count' ? (
              <Count />
            ) : activeTab === 'batch' ? (
              <Batch />
            ) : (
              assertExhaustiveSwitch(activeTab)
            )}
          </Box>
        </LoginContainer>
      </Box>
    </>
  );
}
